const auth0Config = {
  authorizationParams: {
    audience: process.env.AUTH0_AUDIENCE ?? "",
    redirect_uri: `${window.location.origin}/auth/auth0/callback`, // eslint-disable-line camelcase -- Auth0 SDK property
  },
  clientId: process.env.AUTH0_CLIENT_ID ?? "",
  domain: process.env.AUTH0_DOMAIN ?? "",
};

export { auth0Config };
